// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"d207b010","488":"fb420d7f","584":"41ca4f4a","585":"b5fe8a74","648":"1e6956ec","946":"cd0d6085"}[chunkId] + ".chunk.js";
};